import SqueletonPlaceholder from "components/v2/common/SqueletonPlaceholder";

export default function ListingCardSqueleton() {
  return (
    <div style={{ position: "relative" }}>
      <div style={{ cursor: "pointer", margin: 4 }}>
        <div
          style={{
            height: "177px",
          }}
        >
          <SqueletonPlaceholder height="100%" />
        </div>

        <div
          style={{
            padding: 10,
            paddingBottom: 0,
          }}
        >
          <div style={{ height: 20, paddingBottom: 8 }}>
            <SqueletonPlaceholder height="100%" />
          </div>
          <div style={{ paddingBottom: 8, height: 20 }}>
            <SqueletonPlaceholder height="100%" />
          </div>
          <div style={{ paddingBottom: 8, height: 20 }}>
            <SqueletonPlaceholder height="100%" />
          </div>
          <div style={{ paddingBottom: 8, height: 20 }}>
            <SqueletonPlaceholder height="100%" />
          </div>
        </div>
      </div>
    </div>
  );
}
